import React, { PureComponent, Fragment } from 'react';
import Spinner from '../shared/spinner';
import ReactModal from 'react-modal';
import { currencySign, ieCheck } from '../../helpers/utils';
import _filter from 'lodash/filter';
import _uniq from 'lodash/uniq';
import ReactGA from 'react-ga';


ReactModal.setAppElement('#root');

class BasketInfo extends PureComponent {

  constructor (props) {
    super(props);
    this.state = {
      showYoutubeModal: false,
      showMapModal: false,
      showIncludedModal:false,
      highlightShowArrow:false,
      highlightExpanded:false
    }
    this.openYoutubeModal = this.openYoutubeModal.bind(this);
    this.closeYoutubeModal = this.closeYoutubeModal.bind(this);
    this.openMapModal = this.openMapModal.bind(this);
    this.closeMapModal = this.closeMapModal.bind(this);
    this.openIncludeModal = this.openIncludeModal.bind(this);
    this.closeIncludeModal = this.closeIncludeModal.bind(this);
    this.highLightReadMore = this.highLightReadMore.bind(this);

    //USE MAPBOX_DEV FOR NOW
    this.mapboxIndex = window.location.host + process.env.REACT_APP_MAPBOX_INDEX_DEV;

  }


  componentDidUpdate(prevProps, prevState) {
   if(this.props.product !== prevProps.product){
      if(this.renderDashedList(this.props.product.content.highlightList) !== undefined && this.renderDashedList(this.props.product.content.highlightList).length > 4){
        this.setState({highlightShowArrow:true});
      }
    }
  }

  openYoutubeModal(){
    ReactGA.pageview('book.busabout.com/modal/basket-youtube-modal');
    this.setState({showYoutubeModal:true});
  }
  closeYoutubeModal(){ this.setState({showYoutubeModal:false}); }
  openMapModal(){
    ReactGA.pageview('book.busabout.com/modal/basket-map-modal');
    this.setState({showMapModal:true});
  }
  closeMapModal(){ this.setState({showMapModal:false}); }
  openIncludeModal(){
    ReactGA.pageview('book.busabout.com/modal/basket-include-modal');
    this.setState({showIncludedModal:true});
  }
  closeIncludeModal(){ this.setState({showIncludedModal:false}); }



  renderDashedList(dashStr){
    if(dashStr !== undefined){
      let str = dashStr.replace(/(\r\n|\n|\r)/gm,"");
      let arr = str.split("- ");
      arr.shift();
      return arr;
    }
  }

  renderCitiesList(arr, productType){

    if(arr && arr.length > 0){
      let newArr = [];
      for(let i = 0; i < arr.length; i++){
        newArr.push(productType === 'hoho' ? arr[i].city : arr[i].name);
      }
      return  _uniq(newArr).join(", ");
    }else{
      return "";
    }
  }

  renderHighlights(highlightList, showMore){
    return this.renderDashedList(highlightList).map((list, i)=> {
        if(!showMore){
          if(i < 4 ) return <li key={i}><span className="fa fa-check"></span>{list}</li>
        }else{
          return <li key={i}><span className="fa fa-check"></span>{list}</li>
        }
      });
  }

  highLightReadMore(){
    this.setState({highlightExpanded:!this.state.highlightExpanded})
  }

  renderTourNameOrDuration(header, capacity, nameOrDuration){
    if(header.type === 'hoho'){
      return header[nameOrDuration];
    }else{
      return (capacity.length !== 0) ? capacity.header[nameOrDuration] : "";
    }
  }


  render(){

    const { product:{content, content:{media, youTubeVideoId, inclusionList}, header, map}, currency, capacity, upgradesName } = this.props;


    if(Object.keys(content).length === 0) return <Spinner text="Loading products information..." loadClass="loading-spinner" />

    const imageObj = {
      imageQuality:60,
      mapImages:(media === undefined) ? "" :_filter(media, {'title': 'map'})[0].url,
      mapPeople:(media === undefined) ? "" : _filter(media, {'title': 'people'})[0].url,
      mapHighlights:(media === undefined) ? "" : _filter(media, {'title': 'highlightImages'})[0].url
    }

    const youTubeLink = (youTubeVideoId === null) ? "" : "https://www.youtube.com/embed/"+youTubeVideoId+"?rel=0&autoplay=1";
    const includedList = this.renderDashedList(inclusionList).map((list, i)=> { return <li key={i}><span className="fa fa-check"></span>{list}</li> });


    const standardImg = () => {
      return (
        <Fragment>
        <img
        className="lazyload original"
        alt=""
        src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
        data-sizes="auto"
        data-srcset={`https:${imageObj.mapHighlights}?w=254&q=${imageObj.imageQuality} 1x,
        https:${imageObj.mapHighlights}?w=508&q=${imageObj.imageQuality} 2x`} />

        <img
          alt=""
          data-srcset={`https:${imageObj.mapImages}?w=254&q=${imageObj.imageQuality} 1x,
          https:${imageObj.mapImages}?w=508&q=${imageObj.imageQuality} 2x`}
          data-src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          className="lazyload hover-img" />
        </Fragment>
      )
    }

   const ieImg = () => {
      return (
        <img
        alt=""
        src={`https:${imageObj.mapHighlights}?w=254&q=${imageObj.imageQuality}`} />
      )
    }

    return (
      <div className="basketinfo">
        <div className="row">
          <div className="column small-12 large-11 large-offset-0-5">
          <div className="row">
            <div className="column small-12">
                <h3 className="busabout-h3 no-margin">{ this.renderTourNameOrDuration(header, capacity, "name") }<span className="duration-text">{ this.renderTourNameOrDuration(header, capacity, "duration") } days</span></h3>
                <p className="bold no-margin viking-text" style={{ display:upgradesName  === "" ? 'none': 'inline-block' }}> + { upgradesName }</p>
                <p className="bold no-margin" style={{display: header.prices_from.adult === undefined ? 'none' : 'block' }}>Price from <span className="orange-text">{currencySign(currency.currency_mask)}{header.prices_from.adult}</span> per person.</p>
                <p className={`city-text no-margin ${(map && map.length > 8) ? 'big' : ''}`}>Cities: <span className="bold">{this.renderCitiesList(map, header.type)}</span></p>
            </div>
          </div>

        <div className="row">
          <div className="column small-12 medium-12 large-8">

            <div className="row">
              <br className="show-for-medium" />
              <br className="show-for-medium" />
              <div className="column small-12 medium-4 large-3">
                <div className="basketinfo-map" style={{display:(imageObj.mapImages === "") ? "none" : "block"}} onClick={ this.openMapModal }>

                  { ieCheck() ? ieImg() : standardImg() }

                </div>
              </div>

              <div className="column small-12 medium-8 large-9">
                <p className="description-text">{content.descriptionShort}</p>

                <button type="button" className="busabout--cta" style={{display: (youTubeLink === "") ? 'none' : 'inline-block' }} onClick={ this.openYoutubeModal }>
                  <span className="ba-icon ba_icon_youtube"></span>
                  <span>Watch video</span>
                </button>


                <button type="button" className="busabout--cta" onClick={ this.openMapModal }>
                  <span className="ba-icon ba_icon_map_alt2"></span>
                  <span>View map</span>
                </button>

                <button type="button" className="busabout--cta" onClick={this.openIncludeModal}>
                  <span className="ba-icon ba_icon_extra_info"></span>
                  <span className="no-margin orange-text display-line">What is included</span>
                </button>

              </div>
            </div>
          </div>


          <div className="column small-12 medium-12 large-4">
              <div className="basketinfo-highlight">
                <p className="bold">Trip Hightlights:</p>
                <ul>
                  {  this.renderHighlights(content.highlightList, this.state.highlightExpanded) }
                </ul>
                <span className="highlightArrow" style={{display: this.state.highlightShowArrow ? 'block': 'none'}} onClick={this.highLightReadMore}>
                  {this.state.highlightExpanded ? 'Show less' : 'Show more'}
                </span>
              </div>
          </div>
        </div>
      </div>
    </div>

    <ReactModal
        className="youtube-modal"
        overlayClassName="modal-overlay semi-white"
        isOpen={this.state.showYoutubeModal}
        onRequestClose={this.closeYoutubeModal}
        contentLabel="Youtube modal">

        <div className="row">
          <div className="column small-12">
            <div className="youtube-content" onClick={this.closeYoutubeModal}>
              <div className="youtube-iframe-container">
                <iframe title="Youtube modal" src={youTubeLink}  gesture="media" allow="encrypted-media"></iframe>
              </div>
            </div>
          </div>
        </div>


       <button className="modal-close orange" onClick={this.closeYoutubeModal}>
         <span className="fa fa-times fa-2x"></span>
       </button>
     </ReactModal>


     <ReactModal
       className="map-modal"
       overlayClassName="modal-overlay semi-white"
       isOpen={this.state.showMapModal}
       onRequestClose={this.closeMapModal}
       contentLabel="map modal">

      {

        (header.type === "hoho") ?

              <img alt=""
                data-srcset={`https:${imageObj.mapImages}?w=150&q=${imageObj.imageQuality} 1x,
                https:${imageObj.mapImages}?w=300&q=${imageObj.imageQuality} 2x`}
                data-src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                className="lazyload" />

        :

        <iframe title="Map modal" src={`https://book.busabout.com/mapbox-products/src/?mapjson=${process.env.REACT_APP_MAP_API}${header.tour_id}&api_token=${process.env.REACT_APP_API_TOKEN}&tourname=${header.name}&=tourID=${header.group_id}`} frameBorder="0"></iframe>

      }

        <button className="modal-close orange" onClick={this.closeMapModal}>
            <span className="fa fa-times fa-2x"></span>
        </button>
     </ReactModal>



     <ReactModal
       className="include-modal basket"
       overlayClassName="modal-overlay semi-white"
       isOpen={this.state.showIncludedModal}
       onRequestClose={this.closeIncludeModal}
       contentLabel="Include modal">

        <div className="row">
          <div className="column small-12">
            <ul>
            {includedList}
            </ul>
          </div>

          <div className="column small-12">
            <button className="modal-close orange" onClick={this.closeIncludeModal}>
              <span className="fa fa-times fa-lg"></span>
            </button>
          </div>
        </div>

     </ReactModal>

      </div>
    )

  }

}




export default BasketInfo;



// WEBPACK FOOTER //
// ./src/components/basket/basketinfo.js